import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../__root";
import { z } from "zod";

export const acceptInviteRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/accept-invite",
  validateSearch: z.object({
    token: z.string(),
  }),
}).lazy(() => import("./AcceptInvite.lazy").then((d) => d.Route));
